
import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import CGVContent from "../shared/CGVContent";
import { useIsMobile } from "@/hooks/use-mobile";

export const CGVDialog = () => {
  const [cgvDialogOpen, setCgvDialogOpen] = useState(false);
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return (
      <Sheet>
        <SheetTrigger asChild>
          <button className="text-[#b82626] hover:underline">conditions générales de vente</button>
        </SheetTrigger>
        <SheetContent side="bottom" className="h-[80vh] overflow-y-auto px-2 py-6">
          <h2 className="text-xl font-semibold mb-4">Conditions Générales de Vente</h2>
          <div className="pr-2 max-h-full overflow-y-auto">
            <CGVContent />
          </div>
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <AlertDialog open={cgvDialogOpen} onOpenChange={setCgvDialogOpen}>
      <AlertDialogTrigger asChild>
        <button className="text-[#b82626] hover:underline">conditions générales de vente</button>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-h-[80vh] overflow-y-auto max-w-5xl w-[90vw]">
        <AlertDialogHeader>
          <AlertDialogTitle>Conditions Générales de Vente</AlertDialogTitle>
          <AlertDialogDescription className="overflow-y-auto max-h-[60vh] pr-2">
            <CGVContent />
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction>Fermer</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
